import { createReducer } from "@reduxjs/toolkit";
import { getAllReport, getReportId, getReportData } from "./ledgerThunk";

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, dataKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[dataKey] = true;
      state[dataKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[dataKey] = false;
      state[dataKey] = action.payload;
      state.error[errorKey] = null;
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[dataKey] = false;
      state.error[errorKey] = action.payload;
    });
};

const initialState = {
  // Data for each API
  GetReport:  null,
  GetReportfield: null,
  GetReportData: null,

  // Dynamic loading and error states for each API
  loading: {
    GetReport: false,
    GetReportfield: false,
    GetReportData: false,
  },

  error: {
    GetReportError: null,
    GetReportfieldError: null,
    GetReportDataError: null,
  },
};

export const ledgerReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, getAllReport, 'GetReport', 'GetReportError');
  handleAsyncActions(builder, getReportId, 'GetReportfield', 'GetReportfieldError');
  handleAsyncActions(builder, getReportData, 'GetReportData', 'GetReportDataError');
});

export default ledgerReducer;